import React, { useState, useEffect } from 'react';
import { BusinessInfoCardContainer, BusinessName, BusinessInfoCardTable, BusinessInfoButton } from './styled';
import { ImageSlider } from "../../components"

function BusinessInfoCard(props) {

    const business = props.business;

    const [imageList, setImageList] = useState([]);
    const [openInfo, setOpenInfo] = useState(false);

    useEffect(() => {
        setImageList(business.images.map((path, idx) => {
            return require(`../../images/performance/${path}`).default;
        }));
      }, [business]);

    return (            
        <BusinessInfoCardContainer>

            <BusinessName>{business.business_name}</BusinessName>

            <ImageSlider idx={0} list={imageList} />

            { openInfo ? 
                <BusinessInfoCardTable>
                    <table>
                        <tbody>
                            <tr>
                                <td className="head">위치</td>
                                <td>{business.location}</td>
                            </tr>
                            <tr>
                                <td className="head">사업명</td>
                                <td>{business.business_name}</td>
                            </tr>
                            <tr>
                                <td className="head">사업면적</td>
                                <td>{business.business_area}m<sup>2</sup></td>
                            </tr>
                            <tr>
                                <td className="head">연면적</td>
                                <td>{business.total_area}m<sup>2</sup></td>
                            </tr>
                            <tr>
                                <td className="head">용도</td>
                                <td>{business.purpose}</td>
                            </tr>
                        </tbody>
                    </table>
                </BusinessInfoCardTable>
                : null }

            <BusinessInfoButton onClick={() => setOpenInfo(!openInfo)}>자세히 보기</BusinessInfoButton>

        </BusinessInfoCardContainer>
    );
}

export default BusinessInfoCard;